import * as semver from 'semver';

// eslint-disable-next-line import/prefer-default-export
export const Semver = {
  isValid(version) {
    return semver.valid(version) !== null;
  },
};
